import { Button, Flex, Heading, Text } from "@chakra-ui/react";

import { BadgesTable } from "./components/BadgesTable";
import { Layout } from "./components/Layout";
import { BADGES } from "./constants";
import { useWeb3ProviderContext } from "./contexts/Web3Provider";
import { useCallback, useEffect, useState } from "react";
import { Score } from "./components/Score";
import { fetchVerifiableCredential } from "./adapters/api";
import { AsyncTask, VerifiableCredential } from "./domain";

const App = () => {
  const { connectedProvider, connectProvider } = useWeb3ProviderContext();
  const [verifiableCredential, setVerifiableCredential] = useState<
    AsyncTask<VerifiableCredential, string>
  >({ status: "pending" });
  const urlParams = new URLSearchParams(window.location.search);
  const isOAuthRedirection = Array.from(urlParams).length > 0;

  const onUpdateScore = useCallback(() => {
    if (connectedProvider.status === "successful") {
      setVerifiableCredential(
        verifiableCredential.status === "successful"
          ? { status: "reloading", data: verifiableCredential.data }
          : { status: "loading" }
      );
      fetchVerifiableCredential({
        ethereumAddress: connectedProvider.data.address,
      }).then((vc) =>
        setVerifiableCredential({ status: "successful", data: vc })
      );
    }
  }, [connectedProvider]);

  useEffect(() => {
    onUpdateScore();
  }, [connectedProvider]);

  return (
    <Layout>
      {connectedProvider.status === "successful" || isOAuthRedirection ? (
        <>
          <Heading size="2xl">Prove anything to a smart contract</Heading>
          <Text fontSize="xl" paddingTop="6">
            Imagine you can directly prove the right to interact with the smart
            contract using any real-world data.
          </Text>
          <Text fontSize="xl" paddingTop="2">
            Liveness Proof is a demonstration of data aggregation and
            self-tokenisation through zero-knowledge technology to prove that
            you are not a bot.
          </Text>
          <Flex marginTop="12" justifyContent="space-between" gap="16">
            <BadgesTable badges={BADGES} onUpdateScore={onUpdateScore} />
            <Score verifiableCredential={verifiableCredential} />
          </Flex>
        </>
      ) : (
        <>
          <Flex direction="column" align="center">
            <Heading marginTop="32" width="600px" size="2xl" textAlign="center">
              Use your data to generate zk-proofs and interact with smart
              contracts
            </Heading>
            <Button
              colorScheme="primary"
              marginTop="16"
              onClick={connectProvider}
              size="lg"
              isLoading={connectedProvider.status === "loading"}
              fontSize="xl"
            >
              Connect MetaMask
            </Button>
          </Flex>
        </>
      )}
    </Layout>
  );
};

export default App;
